import { render } from "./TicketModal.vue?vue&type=template&id=37644a0b&scoped=true"
import script from "./TicketModal.vue?vue&type=script&lang=js"
export * from "./TicketModal.vue?vue&type=script&lang=js"

import "./TicketModal.vue?vue&type=style&index=0&id=37644a0b&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37644a0b"]])

export default __exports__